import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'antd';
import styled from '@emotion/styled';
import { upperCase } from 'lodash';
import { themeColors } from '../../../constants/themes';
import IconSvg from '../IconSvg';
import Button from '../Button';

const CustomModal = styled(Modal)`
  margin: 25vh auto;
  border-radius: 4px;
  & .ant-modal-header {
    background: ${props => themeColors[props.type]};
    padding: 10px 15px;
    font-color: red;
    height: 3.5em;
    border: 2px solid #ffffff;
    font-family: Heebo-Medium;
    font-size: 12px;
    font-weight: 500;
  }
  & .ant-modal-close-x {
    display: none;
  }

  & .ant-modal-footer {
    background: ${themeColors.backgroundLightGray};
  }
`;

const CloseButton = styled.span`
  cursor: pointer;
  width: 3.5em;
  height: 3.5em;
  position: absolute;
  right: 0;
  top: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 12px;
`;

const TitleText = styled.span`
  margin-left: 1em;
`;

const TmModal = props => {
  const {
    title,
    type,
    children,
    isClosable,
    onClose,
    okButton,
    cancelButton,
    visible,
    mainActionBtn,
    secondaryActionBtn,
  } = props;
  return (
    <CustomModal
      closable={false}
      type={type}
      title={
        <div style={{ color: themeColors[`${type}Font`] }}>
          {type && <IconSvg style={{ position: 'relative', top: '-2px' }} size={22} type={type} />}
          <TitleText>{upperCase(title)}</TitleText>
          {isClosable && (
            <CloseButton onClick={onClose}>
              <IconSvg size={8} type="x" />
            </CloseButton>
          )}
        </div>
      }
      // onOk={okButton && okButton.clickHandler}
      onCancel={onClose}
      visible={visible}
      footer={
        cancelButton || okButton || mainActionBtn || secondaryActionBtn
          ? [
              cancelButton && (
                <Button
                  key="cancel"
                  type={cancelButton.btnType || 'normal'}
                  clickHandler={cancelButton.clickHandler || onClose}
                >
                  {cancelButton.text}
                </Button>
              ),
              okButton && (
                <Button
                  key="ok"
                  type={okButton.btnType || 'primary'}
                  clickHandler={okButton.clickHandler || onClose}
                  disabled={okButton.disabled || false}
                >
                  {okButton.text}
                </Button>
              ),
              mainActionBtn && (
                <Button
                  key="mainActionBtn"
                  type={mainActionBtn.btnType || 'primary'}
                  clickHandler={mainActionBtn.clickHandler || onClose}
                  disabled={mainActionBtn.disabled || false}
                >
                  {mainActionBtn.text}
                </Button>
              ),
              secondaryActionBtn && (
                <Button
                  key="secondaryActionBtn"
                  type={secondaryActionBtn.btnType || 'primary'}
                  clickHandler={secondaryActionBtn.clickHandler || onClose}
                  disabled={secondaryActionBtn.disabled || false}
                >
                  {secondaryActionBtn.text}
                </Button>
              ),
            ]
          : null
      }
    >
      {children}
    </CustomModal>
  );
};

TmModal.propTypes = {
  title: PropTypes.string,
  type: PropTypes.string,
  isClosable: PropTypes.bool,
  children: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  cancelButton: PropTypes.object,
  okButton: PropTypes.object,
  visible: PropTypes.bool,
  onClose: PropTypes.func,
  secondaryActionBtn: PropTypes.oneOfType([PropTypes.object, PropTypes.func]),
  mainActionBtn: PropTypes.oneOfType([PropTypes.object, PropTypes.func]),
};

export default TmModal;
